export const nav = {
    permission: 'ata.meetings:ver',
    section: 'Minutes',
    title: 'Meetings',
    icon: 'event_note',
    route: '/meetings',
    sequence: 10,
};

export default [
    {
        path: '/meetings',
        name: 'meetings',
        component: () => import('./pages/MeetingsPage.vue'),
        meta: { requiresAuth: true, permission: 'ata.meetings:ver' },
    },
    {
        // Detalhe da reuniao: audio, transcricao e falantes. Sem item de menu (abre pela lista).
        path: '/meetings/:meetingId',
        name: 'meeting',
        component: () => import('./pages/MeetingPage.vue'),
        meta: { requiresAuth: true, permission: 'ata.meetings:ver' },
    },
    {
        // Tela de edicao da ata (depois de gerada): formulario das secoes + transcricao para conferir e citar trechos.
        path: '/meetings/:meetingId/minutes/:minutesId/edit',
        name: 'minutes-editor',
        component: () => import('./pages/MinutesEditorPage.vue'),
        meta: { requiresAuth: true, permission: 'ata.meetings:editar' },
    },
    {
        // Gravador em aba propria, sem menu: aberto pelo botao "Gravar reuniao" da reuniao.
        path: '/meetings/:meetingId/recorder',
        name: 'meeting-recorder',
        component: () => import('./pages/RecorderPage.vue'),
        meta: { requiresAuth: true, permission: 'ata.meetings:editar', layout: 'blank' },
    },
];
